import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { FOLLOW_UP_COLLECTION_WRITE_PERMISSION } from "../enum";

const FollowUpCollectionAccessControl = ({ children }) => (
    <ComponentAccessControl baseResources={FOLLOW_UP_COLLECTION_WRITE_PERMISSION}>
        {children}
    </ComponentAccessControl>
);

export default FollowUpCollectionAccessControl;
